import { ArrowUpDown } from "lucide-react";

import { useURLParamsData } from "@/shared/hooks/useURLParamsData";

interface SortButtonProps {
  sort: string;
  title: string;
}

export function SortButton({ sort, title }: SortButtonProps) {
  const { setSort, setOrder, order } = useURLParamsData();

  return (
    <button
      className="flex items-center decoration-thColor hover:underline max-md:px-0"
      onClick={() => {
        setSort(sort);
        setOrder(order === "desc" ? "asc" : "desc");
      }}
    >
      <p className="text-thColor">{title}</p>
      <ArrowUpDown className="ml-2 h-4 w-4 stroke-thColor" />
    </button>
  );
}
